const $ = jQuery.noConflict()

var self = module.exports = {
  init: function(trigger) {
    self.events.click(trigger)
    self.events.change(trigger)
    self.events.load()
  },

  events: {
    click: function(trigger) {
      $(document).on('click', trigger, function(e) {
     
        var target = $(this).data('submit')

        var form = target ? target : $(this).closest('form')

        if ($(this).is('a, button')) {
          self.service.submit(form)
        } 

        if ($(form).attr("id") === "property-search") {
          self.service.updatePropertySearchTitle(form);
        }

      })
    },

    change: function(trigger) {
      $(document).on('change', trigger, function(e) {
        var target = $(this).data('submit')
        var form = target ? target : $(this).closest('form')
        var inputName = $(this).attr('name')

        if(inputName == 'location') {
          self.service.updateSort()
        }

        self.service.submit(form)
      });
    },
    load: function () {
      var location = $("#property-search-location").val();
      // alert(location);
      if(location){
        $("#property-search-radius").prop("selectedIndex", 0);
        self.service.submit('#property-search');
      }
    },
  },

  service: {
    submit: function(form) {
      $(form).trigger('submit')
    },
    updateSort: function(form) {
      var sort = $('[name="sort"]')
      $(sort).val('distance')
    },

    updatePropertySearchTitle: function (form) {
      var searchTitle = $("#property-search-title");
      var searchDescription = $('#property-search-description');
      var location = $("#property-search-location").val();
      var searchLocation = $("#property-search-search-title").val();
      var searchDescriptionForm = $("#property-search-search-description").val();
      var searchDescriptionAjax = ajax.search_description;
      // console.log(searchDescriptionAjax);

      /*if(searchDescriptionAjax){
        $(searchDescriptionAjax).each(function(index, value){  
            if(value.link.title.toUpperCase() == location.toUpperCase()){
              searchDescription.text(value.description);
            }
        });  
      }*/

      if(location.toUpperCase() == searchLocation.toUpperCase() ){
        searchDescription.text(searchDescriptionForm);
      }else{
        searchDescription.text('');
      }
    },

  }
}
